import { OPEN_CUSTOMS_AND_CROSSING } from '@/features/shared/helpers/typologies';

export enum REGISTER_NEW_REQUEST_FORM {
  direction = 'direction',
  trailerVrn = 'trailerVrn',
  tractorVrn = 'tractorVrn',
  folderTypologyId = 'folderTypologyId',
  vehicleNationality = 'vehicleNationality',
  haulierGbEoriNumber = 'haulierGbEoriNumber',
  haulierEuEoriNumber = 'haulierEuEoriNumber',
  crossingRequestedDate = 'crossingRequestedDate',
  internalClientReference = 'internalClientReference',
  requiresGmrAndEloFormality = 'requiresGmrAndEloFormality',
}

export type RegisterNewRequestForm = {
  direction: string;
  trailerVrn: string;
  tractorVrn: string;
  vehicleNationality: string;
  haulierGbEoriNumber: string;
  haulierEuEoriNumber: string;
  crossingRequestedDate: string;
  internalClientReference: string;
  requiresGmrAndEloFormality: string;
  folderTypologyId: OPEN_CUSTOMS_AND_CROSSING;
};
